export const initialUrl='/ticket'